import { useTranslation } from "react-i18next";
import { createFormContext } from "@mantine/form";
import { Questionnaire, QuestionnaireInput } from "src/graphql/generated/graphql";

export const parseQuestionnaireInput = (questionnaire: Questionnaire): QuestionnaireInput => {
    return questionnaire;
};

export const [QuestionnaireFormProvider, useQuestionnaireFormContext, useForm] =
    createFormContext<QuestionnaireInput>();

export const useQuestionnaireForm: typeof useForm = (values) => {
    const { t } = useTranslation(["common"]);

    return useForm({
        ...values,
        initialValues: {
            ...values.initialValues,
            questions: values.initialValues?.questions || [],
        },
        validate: {
            // type: value => !(value?.length > 0) ?
            //     t("questionnaire_error_missingtype") : null,
            // name: value => !(value?.length > 0) ?
            //     t("questionnaire_error_missingname") : null,
            questions: {
                // content: value => !(value?.length > 0) ?
                //     t("questionnaire_error_missingquestioncontent") : null,
                // type: value => !(value?.length > 0) ?
                //     t("questionnaire_error_missingquestiontype") : null,
                // options: {
                //     value: value => !(value?.length > 0) ?
                //         t("questionnaire_error_missingquestionoptionvalue") : null,
                // },
            },
        },
    });
};
